import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 11v8l3 -3m-6 0l3 3","key":"svg-0"}],["path",{"d":"M9 7l1 0","key":"svg-1"}],["path",{"d":"M14 7l1 0","key":"svg-2"}],["path",{"d":"M19 7l1 0","key":"svg-3"}],["path",{"d":"M4 7l1 0","key":"svg-4"}]]

const IconFoldDown = createReactComponent('outline', 'fold-down', 'FoldDown', __iconNode);

export default IconFoldDown;